import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type PostalAddressModel from './postal-address.ts';
import type UserModel from './user.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class CreditorModel extends Model {
  @attr declare accountName: string;
  @attr declare accountNumber: string;
  @attr declare bankName: string;
  @attr declare isActive: boolean;
  @attr declare paymentAccountSetupType: string;
  @attr declare routingNumber: string;
  @attr declare checkNumber: number;

  @belongsTo('postal-address', { async: false, inverse: null })
  declare postalAddress: PostalAddressModel;

  @belongsTo('postal-address', { async: false, inverse: null })
  declare billingAddress: PostalAddressModel;

  @belongsTo('user', { async: false, inverse: null })
  declare user: UserModel;

  [Type] = 'creditor' as const;
}
